// extracted by mini-css-extract-plugin
export default {"card_body":"ProblemStatement_card_body__Yv-+L"};